module.exports = __webpack_public_path__ + "c27c9700726723834288805a3d42c370.MP3";